import { Subscription } from 'rxjs';
import { Utils } from 'formiojs';
import { CategoryConfig } from './../models/config.model';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { FormControl } from '@angular/forms';
import { SortHelper } from '../../../helpers/sort.helper';
import { ResourceNameService } from 'dp-formio';


@Component({
    selector: 'app-category-card',
    templateUrl: './category-card.component.html',
    // styleUrls: ['./category-card.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class CategoryCardComponent implements OnInit, OnDestroy {
    @Input() data: any;
    @Input() customOptions: any;
    @Input() processConfig: any;

    @Input() category: CategoryConfig;

    @Input() isSub = false;
    @Output() onOpenCategory = new EventEmitter();
    @Output() onOpenSubCategory = new EventEmitter<any>();

    options: any[] = [];
    selected = new FormControl(null, []);
    isLoading = false;
    isOpen = false;

    sub: Subscription;

    constructor(private resourceNameService: ResourceNameService) { }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }

    openCatalog() {
        this.onOpenCategory.emit();
    }
    openSubCategory(key) {
        this.onOpenSubCategory.emit({
            key,
            parent: this.category
        });
    }

    openChanged(isOpen: boolean) {
        this.isOpen = isOpen;
        if (isOpen && !this.category?.subCategoriresObjectForSelect?.length) {
            this.isLoading = isOpen;
            this.options = [];
            this.selected.reset();

            const categoryResource = Utils.interpolate(this.customOptions.categoryResource, { data: this.data });
            const subCategoryQuery = Utils.interpolate(this.customOptions.subCategoryQuery, { data: this.data, key: this.category.key });
            const subCategorySelect = Utils.interpolate(this.customOptions.subCategorySelect, { data: this.data, key: this.category.key });

            this.resourceNameService.loadCustomByFilterdKey(categoryResource, `${subCategoryQuery}${subCategorySelect}`)
                .subscribe((data: any[]) => {
                    this.options = SortHelper.recursiveSort(data.map<CategoryConfig>(c => {
                        const item = new CategoryConfig();
                        const mappedItem = { _id: c._id, ...c.data };
                        SortHelper.copyProps(mappedItem, item);
                        item.parentCategoryObject = this.category;
                        return item;
                    }), 'asc');

                    this.category.subCategoriresObjectForSelect = this.options;
                    this.selected.setValue(this.options);
                    this.isLoading = false;
                },
                    (error) => {
                        this.options = [];
                        console.error(error);
                        this.selected.setValue(this.options);
                        this.isLoading = false;
                    }
                );
        } else {
            this.options = this.category.subCategoriresObjectForSelect;
            this.selected.setValue(this.options);
        }
    }
}